import {DAYS_IN_WEEK, DAYS_IN_YEAR, HOURS_IN_DAY, MINUTES_IN_HOUR, SECONDS_IN_MINUTE} from "../modules/constants";

const PLURAL_THRESHOLD = 1;
const MAX_TIME_COMPONENTS = 2;
const MINUTES_HIDE_SECONDS_THRESHOLD = 5;

const updateCifsShareExpiration = (wait = 0) => {
  const seconds = 1000;
  const minutes = seconds * SECONDS_IN_MINUTE;
  const hours = minutes * MINUTES_IN_HOUR;
  const days = hours * HOURS_IN_DAY;
  const weeks = days * DAYS_IN_WEEK;
  const years = days * DAYS_IN_YEAR;

  let waitTime = years;

  clearTimeout(window.cifs_share_counter);
  window.cifs_share_counter = setTimeout(function() {
    let all_expired = true;

    const cells = document.querySelectorAll(`.local_shares .activitytable [data-expire], .cloud_shares .activitytable [data-expire]`);
    if (cells.length === 0) {
      updateCifsShareExpiration(seconds);
    }
    cells.forEach((element) => {
      const expireTs = parseInt(element.getAttribute('data-expire'));
      if (expireTs) {
        const now = new Date();
        const expirationDate = new Date(expireTs * seconds);
        const timeToExpire = expirationDate - now;
        let timeLeft = '';
        let nextWait = wait;

        if (timeToExpire > 0) {
          const numSeconds = Math.floor((timeToExpire % minutes) / seconds);
          const numMinutes = Math.floor((timeToExpire % hours) / minutes);
          const numHours = Math.floor((timeToExpire % days) / hours);
          const numDays = Math.floor((timeToExpire % weeks) / days);
          const numWeeks = Math.floor((timeToExpire % years) / weeks);
          const numYears = Math.floor(timeToExpire / years);

          let entitiesCount = 0;
          nextWait = days;

          all_expired = false;

          if (numYears) {
            timeLeft += numYears + ' ' + (numYears > PLURAL_THRESHOLD ? _years : _year) + ' ';
            entitiesCount++;
          }
          if (numWeeks) {
            timeLeft += numWeeks + ' ' + (numWeeks > PLURAL_THRESHOLD ? _weeks : _week) + ' ';
            entitiesCount++;
          }
          if ((numDays || numWeeks) && entitiesCount < MAX_TIME_COMPONENTS) {
            timeLeft += numDays + ' ' + (numDays > PLURAL_THRESHOLD ? _days : _day) + ' ';
            nextWait = hours;
            entitiesCount++;
          }
          if ((numHours || numDays) && entitiesCount < MAX_TIME_COMPONENTS) {
            timeLeft += numHours + ' ' + (numHours > PLURAL_THRESHOLD ? _hours : _hour) + ' ';
            nextWait = minutes;
            entitiesCount++;
          }
          if ((numMinutes || numHours) && entitiesCount < MAX_TIME_COMPONENTS) {
            timeLeft += numMinutes + ' ' + _min + ' ';
            nextWait = minutes;
            entitiesCount++;
          }
          if (numMinutes >= MINUTES_HIDE_SECONDS_THRESHOLD) {
            // don't show seconds if expiration more that in 5 minutes
            nextWait = minutes;
            entitiesCount++;
          }
          if (entitiesCount < MAX_TIME_COMPONENTS) {
            timeLeft += numSeconds + ' ' + _sec;
            nextWait = seconds;
          }
        } else {
          timeLeft = _client_local_share_pending_unmount;
          const row = element.closest('tr');
          if (row) {
            const discardLink = row.querySelector('.js-cifs_supress');
            if (discardLink) {
              discardLink.style.display = "none";
              element.innerText = timeLeft;
            }
          }
        }
        waitTime = Math.min(waitTime, nextWait);
        element.innerText = timeLeft;
        element.setAttribute('data-axTooltip', timeLeft);
      }
    });

    if (!all_expired) {
      updateCifsShareExpiration(waitTime);
    }
  }, wait);
};

export {updateCifsShareExpiration};
